<template>
  <fragment>
    <v-card>
      <v-card-title class>
        <span class="headline mb-4">{{
          emp ? 'Editar Empleado' : 'Nuevo Empleado'
        }}</span>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-form class="pa-0" ref="form" lazy-validation>
          <v-row class="pb-2">
            <v-col
              @mouseenter="hover = true"
              @mouseleave="hover = false"
              cols="3"
              class="pa-0 mx-2 img-container"
            >
              <img
                :src="editedItem.img || require('@/assets/imgs/no-img21.png')"
                title="Subir imagen"
              />
              <v-fade-transition>
                <v-overlay
                  absolute
                  v-if="hover && !isImgLoading"
                  class="img-upload"
                >
                  <label for="imgs">
                    <v-icon dark>mdi-cloud-upload</v-icon>
                    <input
                      type="file"
                      id="imgs"
                      name="img"
                      accept="image/*"
                      @input="onUploadImg"
                    />
                  </label>
                </v-overlay>
              </v-fade-transition>
              <v-progress-circular
                v-if="isImgLoading"
                indeterminate
                color="primary"
              >
              </v-progress-circular>
            </v-col>
            <v-col cols="8">
              <v-text-field
                required
                dense
                :rules="rules.req"
                v-model.trim="editedItem.name"
                label="Nombre"
              ></v-text-field>
              <v-text-field
                required
                dense
                v-model.trim="editedItem.department"
                :rules="rules.req"
                label="Departamento"
              ></v-text-field>
              <v-select
                dense
                :items="farmNames"
                v-model="editedItem.farm"
                label="Finca"
              >
              </v-select>
              <v-text-field
                dense
                v-model.trim="editedItem.post"
                label="Puesto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="py-0">
              <v-text-field
                dense
                v-model="editedItem.address"
                label="Dirección"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" class="py-0">
              <v-text-field
                dense
                v-model="editedItem.phone"
                label="Telefono"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" class="py-0">
              <date-picker
                :date="editedItem.birth"
                @onChangeDate="onSetBirth"
                label="Fecha de Nacimiento"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="py-0">
              <v-text-field
                dense
                v-model.trim="editedItem.bankAcc"
                label="Cuenta Bancaria"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="py-0">
              <v-text-field
                dense
                v-model.trim="editedItem.dpi"
                label="DPI"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6" class="py-0">
              <date-picker
                :error="
                  !editedItem.entry
                    ? 'Empleado sin ingreso no se agregará a la asistencia del día siguiente'
                    : null
                "
                :date="editedItem.entry"
                @onChangeDate="editedItem.entry = $event"
                label="Fecha de Ingreso"
              />
            </v-col>
            <v-col cols="12" sm="6" class="py-0">
              <date-picker
                :date="editedItem.exit"
                @onChangeDate="onSetExit"
                label="Fecha de Baja"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" class="font-weight-bold">Salario Diario</v-col>
            <v-col cols="6" class="text-right">
              <v-tooltip left v-if="isSalaryChanged">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="warning" dark v-bind="attrs" v-on="on"
                    >mdi-alert</v-icon
                  >
                </template>
                <span>El Cambio de salario se aplicara el proximo dia</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="6" class="py-0">
              <v-text-field
                v-model.number="editedItem.salaryNomina"
                dense
                type="number"
                label="Nomina"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="6" class="py-0">
              <v-text-field
                v-model.number="editedItem.salaryAyco"
                type="number"
                dense
                label="Ayco"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" class="pt-0 font-weight-bold"
              >Valor de hora extra</v-col
            >
            <v-col cols="6" sm="6" class="py-0">
              <v-text-field
                v-model.number="editedItem.hourNomina"
                type="number"
                dense
                label="Nomina"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="6" class="py-0">
              <v-text-field
                v-model.number="editedItem.hourAyco"
                type="number"
                dense
                label="Ayco"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="6" class="py-0">
              <v-checkbox
                dense
                v-model="editedItem.health"
                label="Tarjeta de salud Y pulmones"
              >
              </v-checkbox>
            </v-col>
            <v-col cols="6" sm="6" class="py-0 d-flex align-center">
              <v-checkbox
                dense
                v-model="editedItem.isSuspended"
                label="Suspendido"
                class="mr-2"
              >
              </v-checkbox>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" small dark v-bind="attrs" v-on="on"
                    >mdi-help-circle
                  </v-icon>
                </template>
                <span>No se agregará a la asistencia del día siguiente</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" class="py-0">
              <v-textarea
                filled
                label="Comentarios"
                rows="2"
                auto-grow
                dense
                no-resize
                v-model="editedItem.comment"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="onClose">Cancelar</v-btn>
        <v-btn
          color="blue darken-1"
          text
          :loading="isSaving"
          :disabled="isSaving || isImgLoading"
          @click="onSave(true)"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          isActivatingEmp
            ? 'Empleado Recontratado'
            : 'Estas seguro que quieres colocar baja?'
        }}</v-card-title>
        <v-card-text class="body-2">{{
          isActivatingEmp
            ? 'Porfavor modifice los datos del empleado'
            : 'Empleado con baja no se agregará a la asistencia del día siguiente'
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="(editedItem.exit = null), (dialog = false)"
          >
            Cancelar</v-btn
          >

          <v-btn color="green darken-1" text @click="dialog = false"
            >Seguro</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dupConfirm" max-width="500">
      <v-card>
        <v-card-title class="headline"
          >Ya existe un empleado con este DPI</v-card-title
        >
        <v-card-text class="body-2"
          >Estas seguro que quieres aggregar?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dupConfirm = false">
            Cancelar</v-btn
          >

          <v-btn color="green darken-1" text @click="onSave(false)"
            >Seguro</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </fragment>
</template>

<script>
import imageService from '@/services/imageService.js';
import DatePicker from './Misc/DatePicker';
import { isWeekAgo } from '../services/timeUtils';
export default {
  props: {
    emp: Object,
  },
  created() {
    this.setEmpToEdit();
  },
  data() {
    return {
      defaultEmp: {
        img: null,
        name: '',
        department: '',
        post: '',
        phone: '',
        bankAcc: '',
        health: false,
        dpi: '',
        farm: '',
        salaryNomina: 0,
        salaryAyco: 0,
        hourAyco: 0,
        hourNomina: 0,
        entry: null,
        exit: null,
        isSuspended: false,
        exitTs: null,
        comment: '',
      },
      editedItem: null,
      rules: {
        req: [(val) => (val || '').length > 0 || 'Este campo es requerido'],
      },
      farmNames: [
        'Sur',
        'San Jose',
        'El Paso',
        'San Jorge',
        'Ipala',
        'General',
        'Mayafresh',
        'Sabana Grande',
      ],
      isImgLoading: false,
      isSaving: false,
      dialog: false,
      hover: false,
      isActivatingEmp: false,
      dupConfirm: false,
    };
  },
  methods: {
    getIsDupEmp() {
      const empDpi = this.editedItem.dpi;
      const emps = this.$store.getters.emps;
      return emps.some((emp) => emp.dpi === empDpi);
    },
    onSetExit(date) {
      if (
        date === null &&
        this.editedItem.exit &&
        isWeekAgo(this.editedItem.exitTs)
      ) {
        this.isActivatingEmp = true;
      } else if (date) this.editedItem.exitTs = Date.now();
      this.editedItem.exit = date;
      this.dialog = true;
    },
    onSetBirth(date) {
      this.editedItem.birth = date;
    },
    setEmpToEdit() {
      this.editedItem = this.emp ? { ...this.emp } : { ...this.defaultEmp };
    },
    async onSave(isCheckDup) {
      if (!this.validate()) return;
      if (isCheckDup && !this.emp && this.editedItem.dpi) {
        const isDupEmp = this.getIsDupEmp();
        if (isDupEmp) {
          this.dupConfirm = true;
          return;
        }
      }
      this.isSaving = true;
      try {
        await this.saveEmp();
        this.onClose();
        if (this.dupConfirm) this.dupConfirm = false;
      } catch (err) {
        this.$store.commit({
          type: 'user/setAlertData',
          alertData: { txt: 'No se pudo guardar el empleado', type: 'failure' },
        });
      } finally {
        this.isSaving = false;
      }
    },
    saveEmp() {
      return this.$store.dispatch({
        type: 'saveEmp',
        editedItem: this.editedItem,
      });
    },
    async onUploadImg(ev) {
      this.isImgLoading = true;
      try {
        const imgSrc = await imageService.readFile(ev.target.files[0]);
        const imgUrl = await imageService.uploadImg(imgSrc);
        this.$set(this.editedItem, 'img', imgUrl);
      } catch (err) {
        this.$store.commit({
          type: 'user/setAlertData',
          alertData: { txt: 'No se pudo subir la imagen', type: 'failure' },
        });
      } finally {
        this.isImgLoading = false;
      }
    },
    onClose() {
      this.resetValidation();
      this.$router.push(this.emp ? '../' : './');
    },
    validate() {
      return this.$refs.form.validate();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
  computed: {
    isBeforeQuincena() {
      if (this.isActivatingEmp) return true;
      const day = new Date().getDate();
      if (day === 31 || day === 30 || day === 15) {
        return true;
      }
      return false;
    },
    isSalaryChanged() {
      const { emp, editedItem } = this;
      if (!emp) return;
      return (
        emp.salaryNomina !== editedItem.salaryNomina ||
        emp.salaryAyco !== editedItem.salaryAyco ||
        emp.hourAyco !== editedItem.hourAyco ||
        emp.hourNomina !== editedItem.hourNomina
      );
    },
  },
  watch: {
    emp() {
      this.setEmpToEdit();
    },
  },
  components: {
    DatePicker,
  },
};
</script>
